import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const ChevronDownIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <svg
        data-name="Icons / chevron-down"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path data-name="Path 399" d="M0 0h24v24H0z" fill="none" />
        <path
          data-name="Path 400"
          d="m6 9 4 4 4-4"
          transform="translate(2 1)"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5px"
          fill="none"
        />
      </svg>
    </SvgIcon>
  );
});
